export default "__VITE_ASSET__Dg1Y14GZ__"